import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/lib/auth/require-role";
import TrashPage from "@/features/trash";

// Admin-only: trash list + restore + hard-delete + empty-trash all require
// admin role on the BE. Block direct-URL navigation for non-admins so the
// UX matches the sidebar visibility (adminOnly entry).
export const Route = createFileRoute("/_admin/trash")({
  beforeLoad: () => requireRole("admin"),
  component: TrashPage,
});
